<template>
  <div>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="my-auto">
            <v-list-item class="px-3">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0 px-1">
                <div class="blue--text">
                  {{ $getDeepObj(initValue, 'ptk.nama') }}
                </div>
                <div class="black--text">
                  <span v-if="$getDeepObj(initValue, 'ptk.no_ukg')">
                    <b>Nomor.UKG: </b> {{ $getDeepObj(initValue, 'ptk.no_ukg') }}
                  </span>
                  <span v-else> <b>Email: </b> {{ $getDeepObj(initValue, 'ptk.email') }} </span>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <base-form-generator :schema="schema.dasar" v-model="form" class="pt-5 px-3" />
        <template v-if="Number(form.k_moda) === 1">
          <template v-for="(rekaman, id) of schema.rekaman">
            <v-row :key="id" dense no-gutters>
              <v-col cols="12" md="9">
                <base-form-generator
                  :schema="[rekaman]"
                  v-model="form.url_rekaman"
                  class="pt-5 px-3"
                  @input="getDurasi(form.url_rekaman[id], id)"
                />
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex justify-space-between mt-8">
                  <v-btn
                    color="error"
                    class="white--text"
                    @click="onDelRekaman"
                    :disabled="id === 0 || id + 1 < rekamans"
                    elevation="0"
                  >
                    <v-icon left dark>
                      mdi-delete
                    </v-icon>
                    Hapus
                  </v-btn>
                  <span class="mt-2 mr-md-5 blue--text text-left">{{ (durasis && durasis[Number(id)]) || '' }}</span>
                </div>
              </v-col>
            </v-row>
          </template>
          <v-row>
            <v-col cols="12">
              <div class="px-3">
                <v-btn @click="onAddRekaman" color="secondary" elevation="0" :disabled="rekamans === 3">
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Tambah tautan
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
    <v-card v-if="form.k_moda" class="mx-auto mt-5" flat>
      <v-card-text>
        <template>
          <div v-if="berkasesBukti.length">
            <template v-for="(berkas, id) of berkasesBukti">
              <v-row class="px-3" :key="id">
                <v-col cols="12" sm="12" md="5">
                  <span :class="[`px-0 body-2 info--text`]" style="height: 24px">
                    Judul bukti fisik kegiatan ke-{{ id + 1 }}
                  </span>
                  <v-text-field :value="berkas.judul" outlined single-line dense disabled hide-details />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="mt-6">
                    <v-btn
                      color="success"
                      class="white--text mr-2"
                      elevation="0"
                      :href="berkas.url_berkas"
                      target="_blank"
                    >
                      <v-icon left dark>
                        mdi-eye
                      </v-icon>
                      Lihat
                    </v-btn>
                    <v-btn color="error" class="white--text" @click="onDelBerkas(berkas)" elevation="0">
                      <v-icon left dark>
                        mdi-delete
                      </v-icon>
                      Hapus
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </template>
          </div>
          <div v-else>
            <v-row class="px-3">
              <v-col cols="12">
                <div>
                  <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px">
                    Bukti fisik dokumen yang relevan
                  </span>
                </div>
                <div>
                  <span class="subtitle-1">Belum ada <strong>bukti fisik dokumen</strong> yang diunggah</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <v-btn
          @click="onAddBerkas('bukti')"
          color="secondary"
          elevation="0"
          class="mt-3 mx-3"
          :disabled="berkasesBukti.length === 3"
        >
          <v-icon left dark>
            mdi-plus
          </v-icon>
          Tambah berkas
        </v-btn>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-5" flat>
      <v-card-text>
        <template>
          <div v-if="berkasesFoto.length">
            <template v-for="(berkas, id) of berkasesFoto">
              <v-row class="px-3" :key="id">
                <v-col cols="12" sm="12" md="5">
                  <span :class="[`px-0 body-2 info--text`]" style="height: 24px">
                    Judul foto dokumentasi kegiatan ke-{{ id + 1 }}
                  </span>
                  <v-text-field :value="berkas.judul" outlined single-line dense disabled hide-details />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="mt-6">
                    <v-btn
                      color="success"
                      class="white--text mr-2"
                      elevation="0"
                      :href="berkas.url_berkas"
                      target="_blank"
                    >
                      <v-icon left dark>
                        mdi-eye
                      </v-icon>
                      Lihat
                    </v-btn>
                    <v-btn color="error" class="white--text" @click="onDelBerkas(berkas)" elevation="0">
                      <v-icon left dark>
                        mdi-delete
                      </v-icon>
                      Hapus
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </template>
          </div>
          <div v-else>
            <v-row class="px-3">
              <v-col cols="12">
                <div>
                  <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px">
                    Foto dokumentasi kegiatan
                  </span>
                </div>
                <div>
                  <span class="subtitle-1">Belum ada <strong>foto dokumentasi kegiatan</strong> yang diunggah</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <v-btn
          @click="onAddBerkas('foto')"
          color="secondary"
          elevation="0"
          class="mt-3 mx-3"
          :disabled="berkasesFoto.length === 3"
        >
          <v-icon left dark>
            mdi-plus
          </v-icon>
          Tambah berkas
        </v-btn>
      </v-card-text>
    </v-card>
    <berkas ref="berkas" :jenis="jenis" :title="title" @upload="onAddBerkasSave" />
  </div>
</template>
<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
import Berkas from './Berkas';
import { mapActions } from 'vuex';
export default {
  components: { BaseFormGenerator, Berkas },
  props: {
    berkases: {
      type: Array,
      default: () => [],
    },
    initValue: {
      type: Object,
      default: null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    isRefreshUpload: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      jenis: '',
      title: '',
      rekamans: 1,
      berkasesBukti: [],
      berkasesFoto: [],
      durasis: [],
      debounce: null,
    };
  },
  computed: {
    isKolomIsianKasek() {
      const pendampinganKe =
        (this.initValue && this.initValue['formulir'] && this.initValue['formulir']['pendampingan_ke']) ||
        (this.initValue && this.initValue['kPertemuan']);
      return +pendampinganKe >= 11;
    },

    schema() {
      let rekaman = [];
      for (let i = 0; i < this.rekamans; i++) {
        rekaman.push({
          type: 'VTextField',
          name: `${i}`,
          label: `Rekaman Video Conference ke-${i + 1} (taruh URL video rekaman disini)`,
          labelColor: 'secondary',
          hint: '',
          required: false,
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
          prependInnerIcon: 'mdi-video',
        });
      }

      return {
        dasar: [
          {
            type: 'VTextField',
            name: 'jadwal',
            label: 'Jadwal Pertemuan',
            labelColor: 'grey',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'sekolah',
            label: 'Nama Sekolah',
            labelColor: 'grey',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'jenjang',
            label: 'Jenjang Sekolah',
            labelColor: 'grey',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'nama_ks',
            label: 'Nama Kepala Sekolah',
            labelColor: 'grey',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'provinsi',
            label: 'Provinsi',
            labelColor: 'grey',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'kota',
            label: 'Kabupaten / Kota',
            labelColor: 'grey',
            grid: { cols: 12, md: 6 },
            disabled: true,
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'secondary',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'topik_coaching',
            label: 'Topik Coaching',
            labelColor: 'secondary',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: 'jml_hadir',
            label: 'Jumlah Peserta Yang Hadir',
            labelColor: 'secondary',
            hint: '',
            mask: '####',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
            rows: 3,
          },
          {
            type: 'VSelect',
            name: 'k_moda',
            label: 'Moda yang diterapkan',
            labelColor: 'secondary',
            hint: '',
            subHint:
              '*Jika pelaksanaan kegiatannya daring. Maka wajib inputkan link vicon dan bisa unggah foto kegiatannya. Sedangkan jika pelaksanaannya luring. Wajib unggah foto kegiatannya saja.',
            items: this.$mapForMaster(this.masters.lokakarya_moda_psp),
            required: true,
            grid: { cols: 12, md: 6 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.isPreview,
          },
          {
            exist: { status: this.isKolomIsianKasek },
            type: 'VSelect',
            name: 'k_aktif',
            label: 'Status Keaktifan Kepala Sekolah (KS)',
            labelColor: 'secondary',
            hint: '',
            items: this.$mapForMaster(this.masters.aktif),
            required: true,
            grid: { cols: 12, md: 6 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.isPreview,
          },
          {
            exist: { status: this.isKolomIsianKasek },
            type: 'VSelect',
            name: 'k_aktif_pengawas',
            label: 'Status Keaktifan Pengawas',
            labelColor: 'secondary',
            hint: '',
            items: this.$mapForMaster(this.masters.aktif),
            required: true,
            grid: { cols: 12, md: 6 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.isPreview,
          },
          {
            exist: { status: this.isKolomIsianKasek },
            show: { status: this.form['k_aktif'] && +this.form['k_aktif'] !== 1 },
            type: 'VTextarea',
            name: 'catatan_aktif',
            label: 'Keterangan Tambahan KS',
            labelColor: 'secondary',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
            rows: 2,
            autoGrow: true,
            required: this.form['k_aktif'] && +this.form['k_aktif'] !== 1,
            readonly: this.isPreview,
          },
          {
            exist: { status: this.isKolomIsianKasek },
            show: { status: this.form['k_aktif_pengawas'] && +this.form['k_aktif_pengawas'] !== 1 },
            type: 'VTextarea',
            name: 'catatan_aktif_pengawas',
            label: 'Keterangan Tambahan (Keaktifan Pengawas)',
            labelColor: 'secondary',
            grid: { cols: 12, md: 6 },
            outlined: true,
            dense: true,
            singleLine: true,
            rows: 2,
            autoGrow: true,
            required: this.form['k_aktif_pengawas'] && +this.form['k_aktif_pengawas'] !== 1,
            readonly: this.isPreview,
          },
          {
            type: 'VTextarea',
            name: 'rencana_tindakan',
            label: 'Rencana Tindakan',
            labelColor: 'secondary',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            outlined: true,
            dense: true,
            singleLine: true,
            rows: 3,
          },
          {
            type: 'VTextarea',
            name: 'catatan_tambahan',
            label: 'Catatan Tambahan',
            labelColor: 'secondary',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            outlined: true,
            dense: true,
            singleLine: true,
            rows: 3,
          },
        ],
        rekaman: rekaman,
      };
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('diklatPa', ['uploadBerkas', 'action']),

    reset() {
      this.rekamans = 1;
      this.$set(this, 'form', {});
      this.$set(this.form, 'url_rekaman', []);
    },

    initForm(value) {
      if (!value) return;
      const sekolah = this.$getDeepObj(value, 'sekolah.sekolah.data') || {};
      const pspDiklatSekolah = this.$getDeepObj(value, 'sekolah.psp_diklat_sekolah.data') || {};

      for (const dasar of this.schema.dasar) {
        this.$set(this.form, dasar.name, this.$getDeepObj(value, `formulir.${dasar.name}`) || '');
      }

      this.$set(this.form, 'jadwal', this.$getDeepObj(value, 'jadwal'));
      this.$set(this.form, 'sekolah', this.$getDeepObj(sekolah, 'nama') || '');
      this.$set(this.form, 'jenjang', this.$getDeepObj(sekolah, 'm_jenjang.data.singkat') || '');
      this.$set(this.form, 'kota', this.$getDeepObj(sekolah, 'm_kota.data.keterangan') || '');
      this.$set(this.form, 'provinsi', this.$getDeepObj(sekolah, 'm_propinsi.data.keterangan') || '');
      this.$set(this.form, 'nama_ks', this.$getDeepObj(pspDiklatSekolah, 'ptk_kasek.data.nama') || '');

      this.rekamans = (this.$getDeepObj(value, `formulir.url_rekaman`) || []).length || 1;
      this.$set(this.form, 'url_rekaman', []);
      for (let i = 0; i < this.rekamans; i++) {
        this.$set(this.form.url_rekaman, i, this.$getDeepObj(value, `formulir.url_rekaman.${i}.url_meeting`) || '');
        this.durasis[i] = this.$durasiWaktu(this.$getDeepObj(value, `formulir.url_rekaman.${i}.durasi`)) || null;
      }
    },

    initBerkas(berkases) {
      this.berkasesBukti = berkases.filter((berkas) => berkas.jenis === 'bukti');
      this.berkasesFoto = berkases.filter((berkas) => berkas.jenis === 'foto');
    },

    onAddRekaman() {
      this.rekamans += 1;
      this.durasis.push('');
    },

    onDelRekaman() {
      this.durasis.splice(this.rekamans, 1);
      this.rekamans -= 1;
    },

    onAddBerkas(jenis) {
      this.jenis = jenis;
      this.title = jenis === 'bukti' ? 'Bukti Fisik' : 'Foto Kegiatan';
      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onAddBerkasSave(berkas) {
      const pendampingId = this.$getDeepObj(this.initValue, 'pendampinganId');
      const sekolahId = this.$getDeepObj(this.initValue, 'sekolah.psp_kp_pa_sekolah_id');
      const formData = new FormData();

      formData.append('jenis', this.jenis);
      formData.append('judul', berkas.judul);
      formData.append('file', berkas.file);

      this.$refs.berkas.startLoading();
      this.uploadBerkas({
        pendampingId,
        sekolahId,
        tipe: 'individu',
        params: formData,
      })
        .then(() => {
          this.$emit('refresh', { psp_kp_pa_pendampingan_id: pendampingId, psp_kp_pa_sekolah_id: sekolahId });
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onDelBerkas(berkas) {
      const pendampingId = this.$getDeepObj(this.initValue, 'pendampinganId');
      const sekolahId = this.$getDeepObj(this.initValue, 'sekolah.psp_kp_pa_sekolah_id');
      const id = berkas.id;

      this.$confirm('Anda yakin ingin menghapus berkas ?', 'Hapus berkas', {
        tipe: 'error',
      }).then(() => {
        this.action({ pendampingId, sekolahId, tipe: 'individu', id, action: 'delete' }).then(() => {
          this.$emit('refresh', { psp_kp_pa_pendampingan_id: pendampingId, psp_kp_pa_sekolah_id: sekolahId });
        });
      });
    },

    getValue() {
      return {
        form: this.form,
        k_belajar_psp: this.form && this.form.k_belajar_psp ? Number(this.form && this.form.k_belajar_psp) : null,
      };
    },

    validate() {
      return true;
    },

    getDurasi(item, index) {
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },
  },
  watch: {
    initValue: 'initForm',
    berkases: 'initBerkas',
  },
};
</script>
